/**
 * Hệ thống định danh sự kiện của TTS Core Engine (theo chuẩn GDD Mục 6)
 */
export const TTS_EVENTS = {
  // Trạng thái khởi tạo & Model
  INITIALIZING: 'INITIALIZING',
  READY: 'READY',
  LOADING_MODEL: 'LOADING_MODEL',
  MODEL_DOWNLOAD_PROGRESS: 'MODEL_DOWNLOAD_PROGRESS', // { loaded, total, percent, speed }
  MODEL_READY: 'MODEL_READY',

  // Quản lý Segment & Queue
  SEGMENT_QUEUED: 'SEGMENT_QUEUED',
  SEGMENT_GENERATING: 'SEGMENT_GENERATING',
  SEGMENT_READY: 'SEGMENT_READY',
  SEGMENT_CHANGED: 'SEGMENT_CHANGED', // { segmentId, text, index, total }

  // Trạng thái phát âm thanh
  PLAYBACK_STARTED: 'PLAYBACK_STARTED',
  PLAYBACK_PAUSED: 'PLAYBACK_PAUSED',
  PLAYBACK_RESUMED: 'PLAYBACK_RESUMED',
  PLAYBACK_ENDED: 'PLAYBACK_ENDED',
  STOPPED: 'STOPPED',
  COMPLETED: 'COMPLETED',

  // Hiệu năng & Lỗi
  BUFFER_LOW: 'BUFFER_LOW',
  BUFFER_READY: 'BUFFER_READY',
  PERFORMANCE_CHANGED: 'PERFORMANCE_CHANGED',
  ERROR: 'ERROR', // { code, message, recoverable }
};

export const TTS_STATES = {
  IDLE: 'IDLE',
  INITIALIZING: 'INITIALIZING',
  LOADING_MODEL: 'LOADING_MODEL',
  READY: 'READY',
  PLAYING: 'PLAYING',
  PAUSED: 'PAUSED',
  STOPPED: 'STOPPED',
  COMPLETED: 'COMPLETED',
};
